import React, { useState, useEffect, useMemo, useCallback } from 'react';
import InventoryIcon from "@mui/icons-material/Inventory"; // ícone de caixa / estoque
import DeleteIcon from '@mui/icons-material/Delete';
import Chip from '@mui/material/Chip';
import { format } from 'date-fns'; // para formatação de datas
import { CircularProgress, DialogActions, DialogContentText } from '@mui/material';

import { makeStyles, ThemeProvider as CoreThemeProvider, createMuiTheme as createCoreTheme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Tooltip } from '@mui/material';
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Ícone para "finalizar"
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import TextField from '@material-ui/core/TextField';
import RefreshIcon from '@mui/icons-material/Refresh';
import Cookies from 'js-cookie';
import { useTheme, ThemeProvider as MuiThemeProvider, createTheme as createMuiTheme } from "@mui/material/styles";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { useHistory } from "react-router-dom";
import moment from 'moment';
import { useParams } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import { Card, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CheckIcon from '@mui/icons-material/Check';
import { useDropzone } from 'react-dropzone';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CancelIcon from '@mui/icons-material/Cancel';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'; // Ícone apropriado
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import { returnDescricaoInsumo } from '../../../../../../utils/insumoHelpers';

import {
    DataGrid,  
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';

import ButtonGroup from '@material-ui/core/ButtonGroup';



import { styled } from '@material-ui/styles';


import api from '../../../../../../services/api';

import NavegadorGestao from "../../../../../../components/NavBarGestao";


import { Drawer, List, ListItemButton, ListItemText, Divider } from "@mui/material";
import miniatura_pdf from '../../../../../../assets/imgs/miniatura_pdf.png';
import office from '../../../../../../assets/imgs/office.png';
import DescriptionIcon from "@mui/icons-material/Description";


import ContentCopy from "@mui/icons-material/ContentCopy";

import AssignmentIcon from "@mui/icons-material/Assignment";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import BusinessIcon from "@mui/icons-material/Business";
import BuildIcon from "@mui/icons-material/Build";
import SaveIcon from '@mui/icons-material/Save';
import SendIcon from '@mui/icons-material/Send';
import VerifiedIcon from '@mui/icons-material/Verified';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import OpenInNewIcon from "@mui/icons-material/OpenInNew";


const ColorButtonRed = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'red',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'red',
        color: 'whit',
        borderColor: 'blue',
    },
}));


const ColorButtonGreen = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: 'green',
    borderColor: 'black',
    '&:hover': {
        backgroundColor: 'green',
        color: 'blue',
        borderColor: 'blue',
    },
}));



const dropzoneStyles = {
    border: '4px dashed #000000',
    borderRadius: '4px',
    padding: '2px',
    textAlign: 'center',
    cursor: 'pointer',
    margin: '2px 0',
};


export default function GerenciarSaidaEstoque() {
    const [armazenamentos, setArmazenamentos] = useState([]);

    const checkDarkMode = () => {
        const dMode = Cookies.get('darkMode');
        const dTema = Cookies.get('tema');
        if (dMode !== undefined) {
            return dMode === 'true';
        } else if (dTema !== undefined) {
            return dTema === 'dark';
        }
        return false;
    };

    const [darkMode, setDarkMode] = useState(checkDarkMode());

    useEffect(() => {
        const interval = setInterval(() => {
            const isDark = checkDarkMode();
            if (isDark !== darkMode) {
                setDarkMode(isDark);
            }
        }, 1000);

        const handleFocus = () => {
            setDarkMode(checkDarkMode());
        };

        window.addEventListener('focus', handleFocus);
        return () => {
            clearInterval(interval);
            window.removeEventListener('focus', handleFocus);
        };
    }, [darkMode]);

    const themeHelper = React.useMemo(() => ({
        bg: darkMode ? '#121212' : '#ffffff',
        paper: darkMode ? '#1e1e1e' : '#ffffff',
        text: darkMode ? '#ffffff' : '#000000',
        textSecondary: darkMode ? '#aaaaaa' : '#666666',
        border: darkMode ? '#333333' : '#e0e0e0',
        primary: darkMode ? '#bb86fc' : '#1976d2',
        secondary: darkMode ? '#03dac6' : '#dc004e',
        tableHeadBg: darkMode ? '#2d2d2d' : '#f5f5f5',
    }), [darkMode]);

    // Create MUI v4 and v5 themes
    const coreTheme = React.useMemo(() => createCoreTheme({
        palette: {
            type: darkMode ? 'dark' : 'light',
            primary: { main: themeHelper.primary },
            secondary: { main: themeHelper.secondary },
            background: { default: themeHelper.bg, paper: themeHelper.paper },
            text: { primary: themeHelper.text, secondary: themeHelper.textSecondary },
        },
        overrides: {
            MuiTextField: {
                root: darkMode ? {
                    '& label.Mui-focused': { color: 'white' },
                    '& label': { color: 'white' },
                    '& .MuiInput-underline:before': { borderBottomColor: 'white' },
                    '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: 'white' },
                    '& .MuiInput-underline:after': { borderBottomColor: 'white' },
                    '& .MuiInputBase-input': { color: 'white' },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: 'white' },
                        '&:hover fieldset': { borderColor: 'white' },
                        '&.Mui-focused fieldset': { borderColor: 'white' },
                    }
                } : {}
            },
            MuiFormLabel: {
                root: darkMode ? { color: 'white', '&$focused': { color: 'white' } } : {}
            },
            MuiInputBase: {
                input: darkMode ? { color: 'white' } : {}
            },
            MuiInputLabel: {
                root: darkMode ? { color: 'white' } : {}
            },
            MuiSelect: {
                icon: darkMode ? { color: 'white' } : {}
            }
        }
    }), [darkMode, themeHelper]);

    const muiTheme = React.useMemo(() => createMuiTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            primary: { main: themeHelper.primary },
            secondary: { main: themeHelper.secondary },
            background: { default: themeHelper.bg, paper: themeHelper.paper },
            text: { primary: themeHelper.text, secondary: themeHelper.textSecondary },
        },
        components: {
            MuiTextField: {
                styleOverrides: {
                    root: darkMode ? {
                        '& label.Mui-focused': { color: 'white' },
                        '& label': { color: 'white' },
                        '& .MuiInput-underline:before': { borderBottomColor: 'white' },
                        '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: 'white' },
                        '& .MuiInput-underline:after': { borderBottomColor: 'white' },
                        '& .MuiInputBase-input': { color: 'white' },
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: 'white' },
                            '&:hover fieldset': { borderColor: 'white' },
                            '&.Mui-focused fieldset': { borderColor: 'white' },
                        }
                    } : {}
                }
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: darkMode ? { color: 'white' } : {}
                }
            },
            MuiSelect: {
                styleOverrides: {
                    icon: darkMode ? { color: 'white' } : {}
                }
            }
        }
    }), [darkMode, themeHelper]);

    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const [reservasPorUnidade, setReservasPorUnidade] = useState({});




    const [tabelaKey, setTabelaKey] = useState(0);


    const [value, setValue] = React.useState(0);

    const handleChangeTab = (event, newValue) => {
        setValue(newValue);

    }




    const [infoEstoque, setInfoEstoque] = useState([]);

    // ===============================
    // AGRUPAMENTO COM DEBUG
    // ===============================
    const estoquePorUnidade = useMemo(() => {
        console.log('🧮 INFO ESTOQUE BRUTO:', infoEstoque);

        const mapa = {};

        infoEstoque.forEach((registro, idx) => {
            console.log(`➡️ REGISTRO ${idx}:`, registro);

            (registro.itens_estoque || []).forEach((item, i) => {
                console.log(`   📦 ITEM ${i}:`, item);

                const idArm =
                    item.id_armazenamento ??
                    item.armazenamento?.id_armazenamento;

                console.log('      🏷️ ID ARMAZENAMENTO:', idArm);

                const unidade =
                    item.descricao_armazenamento ??
                    item.armazenamento?.descricao ??
                    'INDEFINIDO';

                console.log('      🏢 UNIDADE:', unidade);

                if (!idArm) {
                    console.warn('      ⚠️ ITEM IGNORADO (SEM ID ARMAZENAMENTO)');
                    return;
                }

                if (!mapa[idArm]) {
                    mapa[idArm] = {
                        idArmazenamento: idArm,
                        unidade,
                        disponivel: 0,
                        reservado: 0
                    };
                }

                if (item.status_item === 0) {
                    mapa[idArm].disponivel++;
                    console.log('      ✅ DISPONÍVEL +1');
                }

                const isReservaOS =
                    false

                const isReservaOC = false

                if (item.status_item === 1 && (isReservaOS || isReservaOC)) {
                    mapa[idArm].reservado++;
                    console.log('      🔒 RESERVADO +1');
                }

            });
        });

        console.log('📊 MAPA FINAL:', mapa);

        return Object.values(mapa);
    }, [infoEstoque]);

    async function completaConsultarEstoqueItem(id_insumo) {
        console.log("funcao chamada!");
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            };

            const response = await api.get(
                `v1/protected/almoxarifado/estoque/listarporinsumosrapidoporid/${id_insumo}`,
                { headers }
            );

            console.log(JSON.stringify(response.data));
            let texto = returnDescricaoInsumo(response.data[0]);
            setInformacoesEstoqueInsumo(texto);
            // setInsumoKey(prev => prev + 1);


        } catch (err) {
            console.log("Erro ao listar informações: " + err);
        }
    }


    async function consultarEstoqueItem(insumoSelecionado) {
        try {
            const headers = {
                Authorization: 'Bearer ' + Cookies.get('token')
            };

            const insumo = insumoSelecionado;
            const idInsumo =
                insumo?.id_insumo > 0
                    ? insumo.id_insumo
                    : insumo?.insumo?.id_insumo;

            console.log('🔎 ID INSUMO:', idInsumo);

            const response = await api.get(
                `/v1/protected/almoxarifado/estoque/listarporinsumosrapidoporid/${idInsumo}`,
                { headers }
            );

            console.log('📦 RESPONSE ESTOQUE:', response.data);

            setInfoEstoque(response.data || []);
            setLoading(false);

        } catch (e) {
            console.error('❌ ERRO AO BUSCAR ESTOQUE', e);
            setLoading(false);
        }
    }


    async function buscarInsumo(descricao) {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            };

            const response = await api.get(
                `v1/protected/almoxarifado/estoque/listarporinsumosrapidopordescricao?descricao_busca=${descricao}`,
                { headers }
            );

            setInsumos(response.data);

        } catch (err) {
            console.log("Erro ao listar informações: " + err);
        }
    }
    const [analista, setAnalista] = useState(null);

    const [instalacaoSelecionada, setInstalacaoSelecionada] = useState(null);
    const [descricao, setDescricao] = useState('');





    const handleChange = (event, newValue) => {

        setValue(newValue);

    }


    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const [openModalSolicitarAutorizacao, setOpenModalSolicitarAutorizacao] = useState(false);
    const [idUsuarioAutorizador, setIdUsuarioAutorizador] = useState(null);

    async function solicitarAutorizacaoEspecificaAPI() {
        if (!idUsuarioAutorizador) {
            alert("Por favor, selecione um usuário para autorizar.");
            return;
        }

        setOpenAtualizando(true);
        setBotaoClicado(true);

        try {
            const token = Cookies.get('token');
            const headers = { 'Authorization': 'Bearer ' + token };

            const response = await api.get(
                `v1/protected/almoxarifado/estoque/saidaestoque/solicitarautorizacaoespecifica/${idSaidaEstoque}/${idUsuarioAutorizador}`,
                { headers }
            );

            if (response.status === 200) {
                alert("Solicitação de autorização enviada com sucesso!");
                setSaidaEstoque(response.data);
                setOpenModalSolicitarAutorizacao(false);
            }
        } catch (err) {
            console.error("Erro ao solicitar autorização específica:", err);
            if (err.response && err.response.data) {
                alert(err.response.data);
            } else {
                alert("Erro ao conectar com o servidor.");
            }
        } finally {
            setOpenAtualizando(false);
            setBotaoClicado(false);
        }
    }


    async function atualizarResponsaveisAPI() {
        setOpenAtualizando(true);
        setBotaoClicado(true);

        try {
            const headers = {
                Authorization: "Bearer " + Cookies.get("token")
            };



            const payload = {
                ...saidaEstoque,
                cliente_destinatario: clienteDestinatario ? { id_cliente: clienteDestinatario.id_cliente } : null,
                contato_destinatario: contatoDestinatario ? { id_contato: contatoDestinatario.id_contato } : null
            };

            const response = await api.put(
                `/v1/protected/almoxarifado/saidaestoque/atualizarresponsaveis/${idSaidaEstoque}`,
                payload,
                { headers }
            );

            if (response.data) {
                setSaidaEstoque(response.data);
                alert("Responsáveis atualizados com sucesso!");
            }

        } catch (err) {
            console.error("Erro ao atualizar responsáveis:", err);
            if (err.response && err.response.data) {
                alert(err.response.data);
            } else {
                alert("Erro ao conectar com o servidor.");
            }
        } finally {
            setOpenAtualizando(false);
            setBotaoClicado(false);
        }
    }

    const [itens, setItens] = useState([]);

    const cellStyle = {
        border: '1px solid #ccc',
        padding: 8
    };

    const { idSaidaEstoque } = useParams();
    const [larguraOriginal, setLarguraOriginal] = useState(0);
    const [limiar, setLimiar] = useState(900);

    const [categoria, setCategoria] = useState(0);

    const [ordemServico, setOrdemServico] = useState();


    const [loading, setLoading] = useState(true);
    const [openAtualizando, setOpenAtualizando] = useState(false);
    const [botaoClicado, setBotaoClicado] = useState(false);
    const [projetoSelecionado, setProjetoSelecionado] = useState(null);
    const [propostaSelecionada, setPropostaSelecionada] = useState(null);
    const [ped, setPed] = useState(null);
    const [colaboradorSelecionado, setColaboradorSelecionado] = useState(null);
    const [saidaEstoque, setSaidaEstoque] = useState(null);
    const [solicitantesDisponiveis, setSolicitantesDisponiveis] = useState([]);

    const [clienteDestinatarioInputValue, setClienteDestinatarioInputValue] = useState('');
    const [clienteDestinatarioSearchResult, setClienteDestinatarioSearchResult] = useState([]);
    const [clienteDestinatario, setClienteDestinatario] = useState(null);

    const [contatoDestinatarioInputValue, setContatoDestinatarioInputValue] = useState('');
    const [contatoDestinatarioSearchResult, setContatoDestinatarioSearchResult] = useState([]);
    const [contatoDestinatario, setContatoDestinatario] = useState(null);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (clienteDestinatarioInputValue && clienteDestinatarioInputValue.length >= 3) {
                const token = Cookies.get('token');
                const headers = { 'Authorization': 'Bearer ' + token };
                api.get(`/v1/protected/clientes/buscarpordescricao/${clienteDestinatarioInputValue}`, { headers })
                    .then(response => {
                        setClienteDestinatarioSearchResult(response.data);
                    })
                    .catch(err => {
                        console.error("Erro ao buscar clientes:", err);
                    });
            } else {
                setClienteDestinatarioSearchResult([]);
            }
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [clienteDestinatarioInputValue]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (contatoDestinatarioInputValue && contatoDestinatarioInputValue.length >= 3) {
                const token = Cookies.get('token');
                const headers = { 'Authorization': 'Bearer ' + token };
                api.get(`/v1/protected/contatos/buscarpornome/${contatoDestinatarioInputValue}`, { headers })
                    .then(response => {
                        setContatoDestinatarioSearchResult(response.data);
                    })
                    .catch(err => {
                        console.error("Erro ao buscar contatos:", err);
                    });
            } else {
                setContatoDestinatarioSearchResult([]);
            }
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [contatoDestinatarioInputValue]);

    function getDescricaoCliente(cliente) {
        if (!cliente) return "";
        let nomeExibicao = "";



        if (cliente.tipo_cliente === 0) {
            nomeExibicao = cliente.nome || "";
            if (cliente.sobrenome) {
                nomeExibicao += " " + cliente.sobrenome;
            }
        } else {
            nomeExibicao = cliente.nome_empresarial || cliente.razao_social || cliente.nome_fantasia || "";
        }

        return `ID: ${cliente.id_cliente} - ${nomeExibicao}`;



    }

    const onDropArquivo1 = useCallback(async (acceptedFiles) => {
        // Valida o tipo de arquivo
        // Valida o tipo de arquivo
        if (!acceptedFiles[0].type.includes('application/pdf') && !acceptedFiles[0].type.includes('application/vnd.openxmlformats-officedocument')) {
            alert('Apenas arquivos PDF ou do Office são permitidos.');
            return;
        }

        // Processa o arquivo PNG
        setOpenAtualizando(true);
        try {
            const formData = new FormData();
            formData.append('arquivos', acceptedFiles[0]);
            formData.append('extensao', acceptedFiles[0].name.split('.').pop());

            const response = await api.post('/v1/protected/almoxarifado/saidaestoque/anexararquivoassinado/' + idSaidaEstoque, formData);

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                setSaidaEstoque(cadastro_salvo);
                alert("Arquivo assinado anexado com sucesso!");
            } else {
                alert("Erro ao salvar o arquivo.");
            }
            setOpenAtualizando(false);
        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");
            setOpenAtualizando(false);
        }
    }, []);



    const { getRootProps: getRootArquivoProps1, getInputProps: getInputArquivoProps1 } = useDropzone({
        onDrop: onDropArquivo1,
        multiple: false, // Apenas um arquivo pode ser selecionado
        //accept: '.pdf', // Restringe a aceitação apenas para arquivos .pdf

    });



    async function finalizarParaAutorizacao() {
        setOpenModalSolicitarAutorizacao(true);
    }

    const [openAutorizar, setOpenAutorizar] = useState(false)

    const [codigoValidacao, setCodigoValidacao] = useState("");
    const [open2, setOpen2] = useState(false);


    const handleOpenAutorizar = () => {
        console.log("open autorizar chamado!");

        setOpenAutorizar(true);
    }


    function handleCloseOpenAutorizar() {
        setOpenAutorizar(false);

    }
    async function autorizar() {

        setOpenAtualizando(true);

        if (
            !saidaEstoque.responsaveis ||
            !Array.isArray(saidaEstoque.responsaveis) ||
            saidaEstoque.responsaveis.length < 1
        ) {
            alert("Especifique no mínimo 1 responsável");
            setOpenAtualizando(false);
            return;
        }

        try {
            const headers = {
                Authorization: "Bearer " + Cookies.get("token")
            };

            let pular = false;
            var valido = false;
            const id_user = parseInt(Cookies.get("id_usuario"), 10);

            if (id_user === 3 || id_user === 1) {
                pular = true;
                valido = true;
            }
            const id_usuario = Cookies.get('id_usuario');

            if (!pular) {
                const response2 = await api.post('/v1/protected/validarparaautorizar/key/' + id_usuario + "/" + parseInt(codigoValidacao),
                    { headers: headers });

                valido = response2.data.valid;
            }


            if (!valido) {
                alert("Código Inválido!");
                return;
            }

            const response = await api.get(
                "/v1/protected/almoxarifado/estoque/saidaestoque/autorizar/" + idSaidaEstoque + "/" + Cookies.get("id_usuario"),
                { headers }
            );

            const cadastro_salvo = response.data;

            if (cadastro_salvo) {
                setSaidaEstoque(cadastro_salvo);
                alert("Autorização Realizada");
                handleCloseOpenAutorizar();
            }

        } catch (err) {
            console.error("Erro ao Autorizar, consulte o administrador:", err);

            // 🔴 MOSTRA A MENSAGEM VINDO DO BACKEND
            if (err.response && err.response.data) {
                alert(err.response.data);
            } else {
                alert("Erro de conexão, tente novamente mais tarde.");
            }

        } finally {
            setOpenAtualizando(false);
        }
    }

    async function baixar() {

        setOpenAtualizando(true);
        setBotaoClicado(true);

        if (
            !saidaEstoque.responsaveis ||
            !Array.isArray(saidaEstoque.responsaveis) ||
            saidaEstoque.responsaveis.length < 1
        ) {
            alert("Especifique no mínimo 1 responsável");
            setOpenAtualizando(false);
            setBotaoClicado(false);

            return;
        }

        try {
            const headers = {
                Authorization: "Bearer " + Cookies.get("token")
            };

            const response = await api.get(
                "/v1/protected/almoxarifado/estoque/atualizarsaidaestoque/" + idSaidaEstoque,
                { headers }
            );

            const cadastro_salvo = response.data;

            if (cadastro_salvo) {
                setSaidaEstoque(cadastro_salvo);
                alert("A Saída de Estoque foi finalizada com sucesso!");
                setBotaoClicado(false);

            }

        } catch (err) {
            console.error("Erro ao efetivar saída:", err);

            // 🔴 MOSTRA A MENSAGEM VINDO DO BACKEND
            if (err.response && err.response.data) {
                alert(err.response.data);
                setBotaoClicado(false);

            } else {
                alert("Erro de conexão, tente novamente mais tarde.");
                setBotaoClicado(false);

            }

        } finally {
            setOpenAtualizando(false);
            setBotaoClicado(false);

        }
    }

    const [ordemServicoSelecionada, setOrdemServicoSelecionada] = useState(null);



    function returnDescricaoOrdem(ordem) {

        var texto =
            "ID: " + ordem.id_ordem_servico +
            "\nSolicitação: " + ordem.descricao_solicitacao;

        // ===== Projeto =====
        if (ordem.projeto) {
            texto += "\nProjeto: " + ordem.projeto.descricao_projeto;
        }

        // ===== Proposta =====
        if (ordem.proposta) {
            texto += "\nProposta: " + ordem.proposta.descricao_proposta;
        }

        // ===== Instalação =====
        if (ordem.instalacao) {
            texto += "\nInstalação ID: " + ordem.instalacao.id_instalacao;
        }

        // ===== Ordem de Compra =====
        if (ordem.ordem_compra) {
            texto +=
                "\nOrdem de Compra: " +
                ordem.ordem_compra.id_ordem_compra +
                " - " +
                ordem.ordem_compra.descricao;
        }

        return texto;
    }



    function returnDescricaoUsuario(usuario) {
        var texto = usuario.nome_amigavel;
        return texto;
    }





    const history = useHistory();

    const [isSupervisor, setIsSupervisor] = useState(false);
    const [ordemCompraSelecionada, setOrdemCompraSelecionada] = useState(null);

    async function listarInformacoes() {
        setLoading(true);

        try {
            const token = Cookies.get('token');
            const headers = { 'Authorization': 'Bearer ' + token };

            // 1) buscar entrada de estoque
            const resSaida = await api.get(
                `v1/protected/almoxarifado/saidaestoque/listarsaidaestoqueporid/${idSaidaEstoque}`,
                { headers }
            );
            setOrdemServicoSelecionada(resSaida.data.ordem_servico);
            setOrdemCompraSelecionada(resSaida.data.ordem_compra);

            setSaidaEstoque(resSaida.data);

            if (resSaida.data.cliente_destinatario) {
                setClienteDestinatario(resSaida.data.cliente_destinatario);
            }
            if (resSaida.data.contato_destinatario) {
                setContatoDestinatario(resSaida.data.contato_destinatario);
            }


            const isSupervisor = resSaida.data.supervisores?.some(
                (supervisor) =>
                    parseInt(supervisor.solicitante?.id_usuario, 10) === parseInt(Cookies.get("id_usuario"), 10)
            );

            setIsSupervisor(isSupervisor);

            setItens(resSaida.data.itens_ordem_retirada);


            // 2) buscar armazenamentos (FALTAVA O AWAIT)
            const resArmazenamentos = await api.get(
                'v1/protected/almoxarifado/armazenamento/listar',
                { headers }
            );

            console.log("Armazenamentos:", resArmazenamentos.data);
            setArmazenamentos(resArmazenamentos.data);

            // 3) buscar todos usuários para popular o Autocomplete de Responsáveis
            try {
                const resSolicitantes = await api.get('/v1/protected/user/listartodos', { headers });
                setSolicitantesDisponiveis(resSolicitantes.data);
            } catch (e) {
                console.warn("Erro ao buscar usuários pro autocomplete", e);
            }

            setLoading(false);
        } catch (err) {
            console.error("Erro ao listar as informações: ", err);
            setLoading(false);
        }
    }



    useEffect(() => {
        listarInformacoes();
    }, []);



    function checkDimenssoes() {
        var largura = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

        setLarguraOriginal(largura);


    }





    useEffect(() => {
        checkDimenssoes();
        const handleResize = () => checkDimenssoes();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const [loadingGerarPDF, setLoadingGerarPDF] = useState(false);


    async function gerarPDF() {
        try {
            setLoadingGerarPDF(true); // 🔒 bloqueia a tela

            const headers = {
                Authorization: "Bearer " + Cookies.get("token"),
            };

            const response = await api.get(
                `/v1/protected/almoxarifado/estoque/gerarpdfsaidaestoque/${saidaEstoque.id_saida_estoque}`,
                { headers }
            );

            if (response.data === true) {
                alert("PDF Gerado com sucesso");

                const link =
                    "https://gruporosinetos.com/saidaestoquemidias/" +
                    saidaEstoque.id_saida_estoque +
                    "/saida_estoque" +
                    saidaEstoque.id_saida_estoque +
                    ".pdf";

                window.open(link, "_blank", "noopener,noreferrer");
            } else {
                alert("Erro ao gerar o PDF");
            }

        } catch (err) {
            console.error("Erro ao gerar PDF:", err);

            // 📢 mensagem vinda do backend
            if (err.response && err.response.data) {
                alert(err.response.data);
            } else {
                alert("Erro de conexão, tente novamente mais tarde.");
            }

        } finally {
            setLoadingGerarPDF(false); // 🔓 libera a tela
        }
    }



    function returnDescricaoUnidade(unidade) {

        console.log("unidade: " + unidade);

        var nome = unidade.nome_fantasia;

        var endereco = unidade.logradouro + ", nº " + unidade.numero + ", " + unidade.bairro + ", " + unidade.cidade + " " + unidade.estado + " CEP: " + unidade.cep;


        var texto = nome + " | " + unidade.cnpj;
        return texto;
    }


    function returnDescricaoArmazenamento(armazenamento) {
        try {
            if (!armazenamento || typeof armazenamento !== "object") {
                return "Armazenamento não disponível";
            }



            const {
                descricao = "—",
                sala = "—",
                corredor = "—",
                bloco = "—",
                gondola = "—",
                prateleira = "—",
            } = armazenamento;

            return (
                returnDescricaoUnidade(armazenamento.unidade) + "\n" +
                "Descrição: " + descricao
            );
        } catch (err) {
            console.error("Erro ao gerar descrição do armazenamento:", err);
            return "Erro ao processar dados de armazenamento";
        }
    }

    function resumoArmazenamento(armazenamento) {
        const textoCompleto = returnDescricaoArmazenamento(armazenamento);
        // Retorna até 30 caracteres + "..." se necessário
        return textoCompleto;
        //return textoCompleto.length > 30 ? textoCompleto.substring(0, 30) + "..." : textoCompleto;
    }



    function returnDescricaoSolicitante(usuario) {
        var texto = "ID_Usuario: " + usuario.id_usuario + "\n Nome: " + usuario.nome_amigavel;
        return texto;
    }


    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }


    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick = (param, event) => {
        event.stopPropagation();
    };



    const handleCellClick2 = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick2 = (param, event) => {
        event.stopPropagation();
    };





    const [insumos, setInsumos] = useState([]);
    const [insumoSelecionado, setInsumoSelecionado] = useState(null);
    const [quantidade, setQuantidade] = useState(0);

    function handleSetInsumo(insumo) {
        setInsumoSelecionado(insumo);
    }


    const [quantidadeDoEstoque, setQuantidadeDoEstoque] = useState(0);
    const [quantidadeNoEstoque, setQuantidadeNoEstoque] = useState(0);

    const [temEstoque, setTemEstoque] = useState(false);


    function handleSetInsumoSelecionado(insumo_) {



        setInsumoSelecionado(insumo_);
        consultarEstoqueItem(insumo_);
    }



    const [textoBusca, setTextoBusca] = useState("");

    useEffect(() => {

        if (textoBusca.length < 3) {
            return; // não busca com menos de 3 chars
        }

        const delayDebounce = setTimeout(() => {
            buscarInsumo(textoBusca);
        }, 500);

        return () => clearTimeout(delayDebounce);

    }, [textoBusca]);

    async function buscarInsumo(descricao) {
        try {

            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            };

            const response = await api.get(
                `v1/protected/almoxarifado/estoque/listarporinsumosrapidopordescricao?descricao_busca=${descricao}`,
                { headers }
            );

            setInsumos(response.data);

        } catch (err) {
            console.log("Erro ao listar informações: " + err);
        }
    }


    async function adicionar() {
        const headers = {
            'Authorization': 'Bearer ' + Cookies.get("token")
        };

        if (!insumoSelecionado) {
            alert("Selecione um insumo");
            return;
        }

        const itensParaSalvar = estoquePorUnidade
            .filter(u =>
                reservasPorUnidade[u.idArmazenamento] > 0 &&
                u.disponivel > 0
            )
            .map(u => ({
                id_insumo: insumoSelecionado?.id_insumo ?? insumoSelecionado?.insumo?.id_insumo,
                id_armazenamento: u.idArmazenamento,
                quantidade: reservasPorUnidade[u.idArmazenamento]
            }));

        if (itensParaSalvar.length === 0) {
            alert("Informe ao menos uma quantidade válida");
            return;
        }

        try {
            const id_usuario_logado = parseInt(Cookies.get("id_usuario"), 10);
            let ultimaResposta = null;

            // 🔁 UMA CHAMADA POR ITEM
            for (const item of itensParaSalvar) {
                const cadastro = {
                    id_insumo: item.id_insumo,
                    id_armazenamento: item.id_armazenamento,
                    quantidade: item.quantidade
                };

                ultimaResposta = await api.put(
                    `/v1/protected/almoxarifado/saidaestoque/editarrequerimento/${idSaidaEstoque}/${id_usuario_logado}/inseriritem`,
                    cadastro,
                    { headers }
                );
            }

            // 🔄 usa a última resposta para atualizar o estado
            if (ultimaResposta) {
                setSaidaEstoque(ultimaResposta.data);
                setItens(ultimaResposta.data.itens_ordem_retirada);
            }

            // limpa estado
            setReservasPorUnidade({});
            setInsumoSelecionado(null);
            setInfoEstoque([]);

        } catch (err) {
            console.error("Erro ao cadastrar itens:", err);
            alert("Erro ao salvar um ou mais itens. Verifique e tente novamente.");
        }
    }




    async function handleClickRemocao(event, cellValues) {



        try {

            const headers = {
                'Authorization': 'Bearer ' + Cookies.get("token")
            }

            const id_usuario_logado = parseInt(Cookies.get("id_usuario"));


            const response = await api.delete("/v1/protected/almoxarifado/saidaestoque/editarrequerimento/" + idSaidaEstoque + "/" + id_usuario_logado + "/removeritem/" + cellValues.row.id_item_requerimento,
                { headers: headers });

            const cadastro_salvo = response.data;
            if (cadastro_salvo) {
                alert("Removido!");
                setSaidaEstoque(cadastro_salvo);
                setItens(cadastro_salvo.itens_ordem_retirada);


            } else {
                alert("Erro de Conexão, tente novamente mais tarde");
            }


        } catch (_err) {
            console.log("erro ao cadastrar: " + _err);
            alert("Erro de Conexão, tente novamente mais tarde");

        }


    };

    function returnDescricaoInsumoSimplificada(insumo) {
        try {
            // Tenta acessar diretamente insumo.descricao
            if (insumo?.descricao) {
                return "Descrição: " + insumo.descricao;
            }

            // Se não houver, tenta insumo.insumo.descricao
            if (insumo?.insumo?.descricao) {
                return "Descrição: " + insumo.insumo.descricao;
            }

            // Se nenhum dos dois funcionar
            return "Descrição: não disponível";
        } catch (error) {
            return "Descrição: erro ao obter";
        }
    }

    const [informacoesEstoqueInsumo, setInformacoesEstoqueInsumo] = useState(null);




    async function handleAtualizarArmazenamento(idItem, idArmazenamento) {
        setOpenAtualizando(true);

        try {
            const cadastro = {
                id_armazenamento: idArmazenamento,
            };

            const headers = {
                Authorization: 'Bearer ' + Cookies.get("token"),
            };

            const response = await api.put(
                `/v1/protected/almoxarifado/saidaestoque/editarrequerimento/${idItem}/atualizararmazenamento`,
                cadastro,
                { headers }
            );

            const cadastro_salvo = response.data;

            if (cadastro_salvo) {
                // opcional: atualizar o item no state
                setItens(prev =>
                    prev.map(item =>
                        item.id_item_requerimento === idItem
                            ? { ...item, ...cadastro_salvo }
                            : item
                    )
                );
            }

        } catch (error) {

            console.error("Erro ao atualizar armazenamento:", error);

            if (error.response) {

                const status = error.response.status;
                const mensagem = error.response.data;

                if (status === 409) {
                    // ❌ estoque insuficiente
                    alert(mensagem || "Quantidade insuficiente neste armazenamento");

                } else if (status === 400) {
                    alert(mensagem || "Dados inválidos");

                } else if (status === 404) {
                    alert("Item não encontrado");

                } else {
                    alert("Erro inesperado ao atualizar armazenamento");
                }

            } else {
                alert("Erro de conexão com o servidor");
            }

        } finally {
            setOpenAtualizando(false);
        }
    }





    function InfoBox({
        title,
        subtitle,
        onOpen,
        icon,
    }) {
        return (
            <Box
                sx={{
                    p: 2,
                    borderRadius: 3,
                    boxShadow: 3,
                    bgcolor: "background.paper",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                }}
            >
                <Box display="flex" alignItems="flex-start">
                    {icon && <Box mr={1}>{icon}</Box>}

                    <Box>
                        <Typography fontWeight="bold">
                            {title}
                        </Typography>
                        {subtitle && (
                            <Typography variant="body2" color="text.secondary">
                                {subtitle}
                            </Typography>
                        )}
                    </Box>
                </Box>

                {onOpen && (
                    <IconButton onClick={onOpen}>
                        <OpenInNewIcon />
                    </IconButton>
                )}
            </Box>
        );
    }


    const columnsDataGrid = [

        {
            field: 'acoes',
            headerName: 'Ações',
            headerClassName: 'cabecalho_azul',
            sortable: false,
            width: 70,
            renderCell: (cellValues) => (
                <IconButton
                    color="error" // vermelho
                    onClick={(event) => handleClickRemocao(event, cellValues)}
                >
                    <DeleteIcon />
                </IconButton>
            ),
        },
        {
            headerName: 'ID',
            field: 'id_item_requerimento',
            width: 50,
            headerClassName: 'cabecalho_azul',
        },

        {
            headerName: 'Insumo',
            field: 'insumo',
            id: 3,
            width: 350,
            headerClassName: 'cabecalho_azul',
            renderCell: (params) => {
                const insumo = params.row.insumo;

                // 🔍 Detecta automaticamente o ID correto (dependendo do seu backend)
                const idInsumo = insumo?.id_insumo > 0
                    ? insumo.id_insumo
                    : insumo?.insumo?.id_insumo > 0
                        ? insumo.insumo.id_insumo
                        : null;

                let descricao = returnDescricaoInsumoSimplificada(insumo);
                descricao = descricao.replace(/<br\s*\/?>/gi, '\n');

                return (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        {/* Texto */}
                        <div
                            style={{
                                whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word',
                                wordBreak: 'break-word',
                                flex: 1,
                                marginRight: '8px'
                            }}
                        >
                            {descricao}
                        </div>

                        {/* 🔹 Botão com Tooltip */}
                        {idInsumo ? (
                            <Tooltip
                                title={
                                    <div style={{ backgroundColor: themeHelper.paper, color: themeHelper.text, padding: 10, fontSize: 16 }}>

                                        <div dangerouslySetInnerHTML={{ __html: informacoesEstoqueInsumo ? informacoesEstoqueInsumo : "Sem informações de Estoque" }} />

                                    </div>

                                }
                                placement="top"
                                arrow
                                style={{ backgroundColor: themeHelper.paper }}
                                sx={{ backgroundColor: themeHelper.paper }}
                            >
                                <IconButton
                                    onClick={() => completaConsultarEstoqueItem(idInsumo)}
                                    size="small"
                                >
                                    <InventoryIcon />
                                </IconButton>
                            </Tooltip>
                        ) : null}
                    </div>
                );
            },
        },
        {
            headerName: 'Armazenamento',
            field: 'armazenamento',
            width: 220,
            headerClassName: 'cabecalho_azul',

            renderCell: (params) => {
                const idAtual = Number(params.row.armazenamento?.id_armazenamento || 0);

                return (
                    <Select
                        value={idAtual || ""}
                        fullWidth
                        size="small"
                        displayEmpty

                        onChange={(event) => {
                            const novoId = Number(event.target.value);
                            if (!novoId || novoId === idAtual) return;

                            // 1️⃣ atualiza o grid imediatamente
                            setItens(prev =>
                                prev.map(item =>
                                    item.id_item_requerimento === params.row.id_item_requerimento
                                        ? {
                                            ...item,
                                            armazenamento: {
                                                ...item.armazenamento,
                                                id_armazenamento: novoId
                                            }
                                        }
                                        : item
                                )
                            );

                            // 2️⃣ persiste no backend
                            handleAtualizarArmazenamento(
                                params.row.id_item_requerimento,
                                novoId
                            );
                        }}
                    >
                        <MenuItem value="">
                            <em>Selecione</em>
                        </MenuItem>

                        {armazenamentos.map((arm) => (
                            <MenuItem
                                key={arm.id_armazenamento}
                                value={Number(arm.id_armazenamento)}
                            >
                                {arm.descricao}
                            </MenuItem>
                        ))}
                    </Select>
                );
            },
        },
        {
            headerName: 'Qtd a Retirar',
            field: 'quantidade',
            width: 140,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const quantidade = cellValues.row.quantidade;
                return (
                    <TextField
                        defaultValue={quantidade}

                        variant="outlined"
                    />
                );
            },
        },

        {
            headerName: 'Valor do Item',
            field: 'valor_unitario',
            width: 140,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                return <span>{currencyFormatter.format(cellValues.row.valor_unitario)}</span>;

            },
        },
        {
            headerName: 'Valor Total',
            field: 'valor_total',
            width: 120,
            headerClassName: 'cabecalho_azul',
            renderCell: (cellValues) => {
                const valor_unitario = cellValues.row.valor_unitario || 0;
                const quantidade = cellValues.row.quantidade || 0;
                const total = quantidade * (valor_unitario);
                return <span>{currencyFormatter.format(total)}</span>;
            },
        },





    ];


    return (
        <CoreThemeProvider theme={coreTheme}>
            <MuiThemeProvider theme={muiTheme}>
                <div style={{ backgroundColor: themeHelper.bg, minHeight: '100vh', color: themeHelper.text }}>
                    <NavegadorGestao
                        Almoxarifado={true}
                        OpSaida={true}
                        corFundo={darkMode ? '#1e1e1e' : 'white'}
                        travado={true}
                        corTexto={darkMode ? 'white' : 'black'}
                    />
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        align="flex-start"
                        item xs={12}
                        style={{ width: '100%', margin: 0, padding: 0 }}
                    >



                        <a href="/gestao/operacional/almoxarifado/saidaestoque/listar" style={{ fontSize: 14, paddingTop: 5, paddingBottom: 5, color: themeHelper.text, marginRight: '5px' }}>{"< Operações de Saída de Estoque - "}</a>

                        <a href={"/gestao/operacional/almoxarifado/saidaestoque/gerenciarsaidaestoque/" + idSaidaEstoque} style={{ fontSize: 14, color: themeHelper.text, paddingTop: 5, paddingBottom: 5, marginRight: '5px' }}>{"Saída de Estoque Nº " + idSaidaEstoque}</a>



                    </Grid>


                    <Container style={{ paddingTop: 5 }} >
                        {loading ?
                            <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                            </Skeleton>
                            :
                            <React.Fragment >
                                <Grid container spacing={2}
                                    alignItems="center"
                                    justifyContent="center"
                                >



                                    <Grid
                                        item xs={12}
                                        container
                                        direction="row"
                                        alignItems="center"
                                        justifyContent={"center"}
                                    >


                                        <Box style={{ backgroundColor: themeHelper.paper, width: '100%', alignItems: 'center', }}>
                                            <AppBar position="static" >

                                                <Tabs
                                                    value={value}
                                                    onChange={handleChangeTab}
                                                    indicatorColor="secondary"
                                                    textColor="inherit"
                                                    variant="scrollable"
                                                    scrollButtons="auto"
                                                    aria-label="scrollable auto tabs example"


                                                >
                                                    <Tab label="Informações Iniciais" style={{ backgroundColor: '#1C1C1C' }} />
                                                    <Tab label="Execução" style={{ backgroundColor: 'green' }} />

                                                </Tabs>
                                            </AppBar>

                                        </Box>
                                    </Grid>



                                    <Grid
                                        style={{ paddingTop: 1 }}
                                        container
                                        direction="row"
                                        item xs={12}
                                        alignItems="center"
                                        justifyContent="center"
                                        spacing={2}
                                    >


                                        <SwipeableViews
                                            index={value}
                                            onChangeIndex={handleChangeIndex}
                                            style={{ backgroundColor: themeHelper.paper, width: '100%', alignItems: 'center', }}
                                        >

                                            <Grid
                                                value={value} index={0}
                                                style={{ paddingTop: 20, paddingBottom: 20, paddingLeft: 10, paddingRight: 10 }}
                                                container
                                                direction="row"
                                                item xs={12}
                                                alignItems="stretch"
                                                spacing={3}
                                            >
                                                {/* ROW 1: TIPO, STATUS E CRIAÇÃO */}
                                                <Grid item xs={12} md={4}>
                                                    <Box sx={{ padding: "16px", borderRadius: 2, backgroundColor: themeHelper.paper, border: `1px solid ${themeHelper.border}`, boxShadow: 1, display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                                                        <Typography variant="overline" color="textSecondary" style={{ lineHeight: 1 }}>Tipo da Saída</Typography>
                                                        <Typography variant="body1" style={{ fontWeight: 'bold', marginTop: 8 }}>
                                                            {{
                                                                0: "❓ Não Definido",
                                                                10: "🛠️ Ordem de Serviço",
                                                                20: "📦 Consumo Interno",
                                                                30: "⚠️ Perda / Avaria",
                                                                40: "🔄 Transferência",
                                                                50: "🤝 Empréstimo",
                                                                60: "🤝 Comodato"
                                                            }[saidaEstoque.tipo_saida_estoque] || "❓ Não Definido"}
                                                        </Typography>
                                                    </Box>
                                                </Grid>

                                                <Grid item xs={12} md={4}>
                                                    <Box sx={{ padding: "16px", borderRadius: 2, backgroundColor: themeHelper.paper, border: `1px solid ${themeHelper.border}`, boxShadow: 1, display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                                                        <Typography variant="overline" color="textSecondary" style={{ lineHeight: 1 }}>Status Atual</Typography>
                                                        <Typography variant="body1" style={{ fontWeight: 'bold', marginTop: 8 }}>
                                                            {{
                                                                0: "✏️ Editando",
                                                                1: "🕒 Pré-Autorização",
                                                                2: "✅ Autorizado",
                                                                3: "📦 Baixado"
                                                            }[saidaEstoque.status]}
                                                        </Typography>
                                                    </Box>
                                                </Grid>

                                                <Grid item xs={12} md={4}>
                                                    <Box sx={{ padding: "16px", borderRadius: 2, backgroundColor: themeHelper.paper, border: `1px solid ${themeHelper.border}`, boxShadow: 1, display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                                                        <Typography variant="overline" color="textSecondary" style={{ lineHeight: 1, textAlign: 'center' }}>Criada Por</Typography>
                                                        <Typography variant="body1" style={{ fontWeight: 'bold', marginTop: 8, textAlign: 'center' }}>
                                                            {saidaEstoque.usuario_criador.nome_amigavel}
                                                        </Typography>
                                                        <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center' }}>
                                                            {`${format(new Date(saidaEstoque.data_criacao), 'dd/MM/yyyy HH:mm')}`}
                                                        </Typography>
                                                    </Box>
                                                </Grid>

                                                {saidaEstoque.usuario_autorizador && (
                                                    <Grid item xs={12} md={4}>
                                                        <Box sx={{ padding: "16px", borderRadius: 2, backgroundColor: themeHelper.paper, border: `1px solid ${themeHelper.border}`, boxShadow: 1, display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                                                            <Typography variant="overline" color="textSecondary" style={{ lineHeight: 1, textAlign: 'center' }}>Autorizador Designado</Typography>
                                                            <Typography variant="body1" style={{ fontWeight: 'bold', marginTop: 8, textAlign: 'center', color: '#2e7d32' }}>
                                                                {saidaEstoque.usuario_autorizador.nome_amigavel}
                                                            </Typography>
                                                            <Typography variant="body2" color="textSecondary" style={{ textAlign: 'center' }}>
                                                                ID: {saidaEstoque.usuario_autorizador.id_usuario}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                )}

                                                {/* ROW 2: DESCRIÇÃO */}
                                                <Grid item xs={12}>
                                                    <Box sx={{ padding: "16px", borderRadius: 2, backgroundColor: themeHelper.paper, border: `1px solid ${themeHelper.border}`, boxShadow: 1 }}>
                                                        <TextField
                                                            variant="standard"
                                                            name="descricao"
                                                            label="Descrição da Operação"
                                                            id="descricao"
                                                            value={saidaEstoque.descricao || ""}
                                                            fullWidth
                                                            multiline
                                                            minRows={2}
                                                            InputProps={{ disableUnderline: true, readOnly: true }}
                                                        />
                                                    </Box>
                                                </Grid>

                                                {/* ROW 3: RESPONSÁVEIS */}
                                                <Grid item xs={12}>
                                                    <Box sx={{ padding: "16px", borderRadius: 2, backgroundColor: themeHelper.paper, border: `1px solid ${themeHelper.border}`, boxShadow: 1 }}>
                                                        <Autocomplete
                                                            id="select-solicitantes"
                                                            options={solicitantesDisponiveis || []}
                                                            disableCloseOnSelect
                                                            multiple
                                                            getOptionLabel={(solicitante) => returnDescricaoSolicitante(solicitante).replace(/<br \/>/g, '\n')}
                                                            value={saidaEstoque.responsaveis || []}
                                                            onChange={(event, newValue) => {
                                                                setSaidaEstoque(prev => ({ ...prev, responsaveis: newValue }));
                                                            }}
                                                            filterOptions={(options, { inputValue }) => {
                                                                const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                return options.filter((solicitante) => {
                                                                    const cotacaoText = returnDescricaoSolicitante(solicitante).toLowerCase();
                                                                    return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                                });
                                                            }}
                                                            renderInput={(params) => {
                                                                const inputProps = { ...params.InputProps, disableUnderline: true };
                                                                return (
                                                                    <TextField
                                                                        {...params}
                                                                        variant="standard"
                                                                        label="Responsáveis pela Saída"
                                                                        multiline
                                                                        minRows={1}
                                                                        InputProps={inputProps}
                                                                    />
                                                                );
                                                            }}
                                                            renderOption={(option) => (
                                                                <div dangerouslySetInnerHTML={{ __html: returnDescricaoSolicitante(option) }} />
                                                            )}
                                                            renderTags={(value, getTagProps) =>
                                                                value.map((solicitante, index) => (
                                                                    <Chip
                                                                        label={returnDescricaoSolicitante(solicitante)}
                                                                        {...getTagProps({ index })}
                                                                    />
                                                                ))
                                                            }
                                                        />
                                                    </Box>
                                                </Grid>

                                                {/* ROW 4: DESTINATÁRIOS */}
                                                <Grid item xs={12}>
                                                    <Box sx={{ padding: "16px", borderRadius: 2, backgroundColor: themeHelper.paper, border: `1px solid ${themeHelper.border}`, boxShadow: 1 }}>
                                                        <Grid container spacing={2} alignItems="center">
                                                            <Grid item xs={12} md={6}>
                                                                <Autocomplete
                                                                    id="select-cliente-destinatario"
                                                                    options={clienteDestinatarioSearchResult}
                                                                    getOptionLabel={(option) => getDescricaoCliente(option)}
                                                                    value={clienteDestinatario}
                                                                    onChange={(event, newValue) => {
                                                                        setClienteDestinatario(newValue);
                                                                    }}
                                                                    onInputChange={(event, newInputValue) => {
                                                                        setClienteDestinatarioInputValue(newInputValue);
                                                                    }}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            label="Cliente Destinatário"
                                                                            variant="standard"
                                                                            placeholder="Digite 3 ou mais caracteres..."
                                                                        />
                                                                    )}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <Autocomplete
                                                                    id="select-contato-destinatario"
                                                                    options={contatoDestinatarioSearchResult}
                                                                    getOptionLabel={(option) => option ? `ID: ${option.id_contato} - ${option.nome_contato} - ${option.celular_contato}` : ''}
                                                                    value={contatoDestinatario}
                                                                    onChange={(event, newValue) => {
                                                                        setContatoDestinatario(newValue);
                                                                    }}
                                                                    onInputChange={(event, newInputValue) => {
                                                                        setContatoDestinatarioInputValue(newInputValue);
                                                                    }}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            label="Contato Destinatário"
                                                                            variant="standard"
                                                                            placeholder="Digite 3 ou mais caracteres..."
                                                                        />
                                                                    )}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Grid>

                                                {/* BOTÃO ATUALIZAR */}
                                                <Grid item xs={12}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            size="large"
                                                            startIcon={<SaveIcon />}
                                                            disabled={botaoClicado || openAtualizando}
                                                            onClick={atualizarResponsaveisAPI}
                                                            sx={{
                                                                minWidth: "200px",
                                                                borderRadius: '12px',
                                                                textTransform: 'none',
                                                                fontWeight: 'bold',
                                                                boxShadow: '0 4px 14px 0 rgba(0,118,255,0.39)',
                                                            }}
                                                        >
                                                            {botaoClicado ? "Atualizando..." : "Atualizar Informações Iniciais"}
                                                        </Button>
                                                    </Box>
                                                </Grid>

                                                {/* ROW 3: VINCULOS DE REFERENCIA */}
                                                {(ordemServicoSelecionada || ordemCompraSelecionada) && (
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6" style={{ marginTop: 8, marginBottom: 8, fontWeight: 'bold' }}>
                                                            Referências Vinculadas
                                                        </Typography>
                                                        <Grid container spacing={2}>
                                                            {ordemServicoSelecionada && (
                                                                <Grid item xs={12} md={6}>
                                                                    <InfoBox
                                                                        icon={<AssignmentIcon color="primary" />}
                                                                        title={`OS ${ordemServicoSelecionada.id_ordem_servico}`}
                                                                        subtitle={ordemServicoSelecionada.descricao_solicitacao}
                                                                        onOpen={() => window.open(`/gestao/administracao/ordensdeservicos/editar/${ordemServicoSelecionada.id_ordem_servico}`, "_blank")}
                                                                    />
                                                                </Grid>
                                                            )}
                                                            {ordemServicoSelecionada?.projeto && (
                                                                <Grid item xs={12} md={6}>
                                                                    <InfoBox
                                                                        icon={<BusinessIcon color="secondary" />}
                                                                        title="Projeto"
                                                                        subtitle={ordemServicoSelecionada.projeto.descricao_projeto}
                                                                    />
                                                                </Grid>
                                                            )}
                                                            {ordemServicoSelecionada?.proposta && (
                                                                <Grid item xs={12} md={6}>
                                                                    <InfoBox
                                                                        icon={<DescriptionIcon color="info" />}
                                                                        title="Proposta"
                                                                        subtitle={ordemServicoSelecionada.proposta.descricao_proposta}
                                                                    />
                                                                </Grid>
                                                            )}
                                                            {ordemServicoSelecionada?.instalacao && (
                                                                <Grid item xs={12} md={6}>
                                                                    <InfoBox
                                                                        icon={<BuildIcon color="warning" />}
                                                                        title={`Instalação ${ordemServicoSelecionada.instalacao.id_instalacao}`}
                                                                        onOpen={() => window.open(`/gestao/administracao/instalacaos/gerenciarinstalacao/instalacao/gerenciarinstalacao/${ordemServicoSelecionada.instalacao.id_instalacao}`, "_blank")}
                                                                    />
                                                                </Grid>
                                                            )}
                                                            {ordemServicoSelecionada?.ordem_compra && (
                                                                <Grid item xs={12} md={6}>
                                                                    <InfoBox
                                                                        icon={<ShoppingCartIcon color="success" />}
                                                                        title={`OC ${ordemServicoSelecionada.ordem_compra.id_ordem_compra}`}
                                                                        subtitle={ordemServicoSelecionada.ordem_compra.descricao}
                                                                        onOpen={() => window.open(`/gestao/administracao/ordensdecompras/editar/${ordemServicoSelecionada.ordem_compra.id_ordem_compra}`, "_blank")}
                                                                    />
                                                                </Grid>
                                                            )}
                                                            {ordemCompraSelecionada && (
                                                                <Grid item xs={12} md={6}>
                                                                    <InfoBox
                                                                        icon={<ShoppingCartIcon color="success" />}
                                                                        title={`Ordem de Compra nº ${ordemCompraSelecionada.id_ordem_compra}`}
                                                                        subtitle={ordemCompraSelecionada.descricao}
                                                                        onOpen={() => window.open(`/gestao/administracao/ordensdecompras/editar/${ordemCompraSelecionada.id_ordem_compra}`, "_blank")}
                                                                    />
                                                                </Grid>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                )}

                                                {/* ROW 5: LINHA DO TEMPO */}
                                                <Grid item xs={12}>
                                                    <Typography variant="h6" style={{ marginTop: 8, marginBottom: 8, fontWeight: 'bold' }}>
                                                        Histórico de Movimentação
                                                    </Typography>
                                                    <Box
                                                        sx={{
                                                            padding: "16px",
                                                            borderRadius: 2,
                                                            backgroundColor: themeHelper.paper,
                                                            border: `1px solid ${themeHelper.border}`,
                                                            boxShadow: 1,
                                                            whiteSpace: "pre-line",
                                                            fontSize: '0.95rem'
                                                        }}
                                                    >
                                                        {saidaEstoque.linha_tempo}
                                                    </Box>
                                                </Grid>

                                            </Grid>

                                            <Grid
                                                value={value} index={1}
                                                style={{ paddingTop: 20 }}
                                                container
                                                direction="row"
                                                item xs={12}
                                                alignItems="center"
                                            >
                                                <Grid
                                                    xs={12}
                                                    container
                                                    direction="row"
                                                    align="center"
                                                    justifyContent={'center'}
                                                    style={{ margin: 2 }}
                                                    spacing={1}
                                                >

                                                    <Grid
                                                        container
                                                        align="center"
                                                        justifyContent="center"
                                                        item
                                                        xs={8}
                                                        style={{ padding: 4, textAlign: "center" }}
                                                    >
                                                        {(() => {
                                                            switch (saidaEstoque.status) {
                                                                case 0:
                                                                    return (
                                                                        <span style={{ color: "#f57c00", fontWeight: "bold", fontSize: 18 }}>
                                                                            ✏️ Saída de Estoque Em Aberto
                                                                        </span>
                                                                    );
                                                                case 1:
                                                                    return (
                                                                        <span style={{ color: "#0288d1", fontWeight: "bold", fontSize: 18 }}>
                                                                            🕒 Saída de Estoque em Pré Autorização
                                                                        </span>
                                                                    );
                                                                case 2:
                                                                    return (
                                                                        <span style={{ color: "#2e7d32", fontWeight: "bold", fontSize: 18 }}>
                                                                            ✅ Saída de Estoque Autorizada
                                                                        </span>
                                                                    );
                                                                case 3:
                                                                    return (
                                                                        <span style={{ color: "#2e7d32", fontWeight: "bold", fontSize: 18 }}>
                                                                            📦 Saída de Estoque Baixada
                                                                        </span>
                                                                    );
                                                                default:
                                                                    return (
                                                                        <span style={{ color: "#616161", fontWeight: "bold", fontSize: 18 }}>
                                                                            ❓ Status Desconhecido
                                                                        </span>
                                                                    );
                                                            }
                                                        })()}
                                                    </Grid>


                                                    {
                                                        saidaEstoque.status === 0
                                                        &&
                                                        (<Grid
                                                            container
                                                            align="flex-end"
                                                            justifyContent={'flex-end'}
                                                            item xs={3} style={{ padding: 1 }}>

                                                            <Button style={{ marginTop: 2 }}
                                                                variant="contained"
                                                                color="primary"
                                                                startIcon={<SendIcon />}
                                                                onClick={finalizarParaAutorizacao}
                                                                sx={{
                                                                    borderRadius: '12px',
                                                                    textTransform: 'none',
                                                                    fontWeight: 'bold',
                                                                    padding: '8px 24px',
                                                                    boxShadow: '0 4px 14px 0 rgba(0,118,255,0.39)',
                                                                }}
                                                            >  Solicitar Autorização  </Button>


                                                        </Grid>)

                                                    }


                                                    {
                                                        saidaEstoque.status === 1 && (isSupervisor || parseInt(saidaEstoque.usuario_autorizador.id_usuario) === parseInt(Cookies.get("id_usuario")))
                                                        &&
                                                        (<Grid
                                                            container
                                                            align="flex-end"
                                                            justifyContent={'flex-end'}
                                                            item xs={3} style={{ padding: 1 }}>

                                                            <Button style={{ marginTop: 2 }}
                                                                variant="contained"
                                                                color="success"
                                                                startIcon={<VerifiedIcon />}
                                                                onClick={(e) => handleOpenAutorizar()}
                                                                sx={{
                                                                    borderRadius: '12px',
                                                                    textTransform: 'none',
                                                                    fontWeight: 'bold',
                                                                    padding: '8px 24px',
                                                                    boxShadow: '0 4px 14px 0 rgba(76,175,80,0.39)',
                                                                }}
                                                            >  Autorizar </Button>


                                                        </Grid>)

                                                    }



                                                    {
                                                        saidaEstoque.status === 2
                                                        &&
                                                        (<Grid
                                                            container
                                                            align="flex-end"
                                                            justifyContent={'flex-end'}
                                                            item xs={3} style={{ padding: 1 }}>

                                                            <Button style={{ marginTop: 2 }}
                                                                variant="contained"
                                                                color="success"
                                                                startIcon={<LocalShippingIcon />}
                                                                onClick={baixar}
                                                                disabled={botaoClicado}
                                                                sx={{
                                                                    borderRadius: '12px',
                                                                    textTransform: 'none',
                                                                    fontWeight: 'bold',
                                                                    padding: '8px 24px',
                                                                    boxShadow: '0 4px 14px 0 rgba(76,175,80,0.39)',
                                                                }}
                                                            >  Dar baixa no estoque  </Button>


                                                        </Grid>)

                                                    }


                                                </Grid>


                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="center"
                                                    align="center"
                                                    item xs={12}
                                                    style={{ paddingTop: 3 }}
                                                >


                                                    <Grid
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        align="center"
                                                        item xs={8}
                                                    >

                                                        <Autocomplete
                                                            id="select-insumo"
                                                            options={insumos}
                                                            disableCloseOnSelect
                                                            getOptionLabel={(insumo) =>
                                                                returnDescricaoInsumo(insumo).replace(/<br \/>/g, '\n')
                                                            }
                                                            value={insumoSelecionado}

                                                            onChange={(e, v) => handleSetInsumoSelecionado(v)}

                                                            // 🔥 captura O TEXTO DIGITADO
                                                            onInputChange={(event, newInputValue) => {
                                                                setTextoBusca(newInputValue);
                                                            }}

                                                            filterOptions={(options, { inputValue }) => {
                                                                const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                return options.filter((insumo) => {
                                                                    const insumoText = returnDescricaoInsumo(insumo).toLowerCase();
                                                                    return inputKeywords.some((keyword) => insumoText.includes(keyword));
                                                                });
                                                            }}

                                                            renderInput={(params) => (
                                                                <TextField {...params} label="Insumo" multiline minRows={2} />
                                                            )}

                                                            renderOption={(option) => (
                                                                <div dangerouslySetInnerHTML={{ __html: returnDescricaoInsumo(option) }} />
                                                            )}
                                                        />
                                                    </Grid>

                                                    <Grid container justifyContent="center" style={{ paddingTop: 20 }}>
                                                        <Grid item>
                                                            <div
                                                                style={{
                                                                    maxWidth: 800,        // 👈 ESSENCIAL
                                                                    width: '100%',
                                                                    margin: '0 auto',     // 👈 CENTRALIZA
                                                                    border: '1px solid #ccc',
                                                                    borderRadius: 8,
                                                                    boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
                                                                    padding: 16,
                                                                    backgroundColor: '#fff'
                                                                }}
                                                            >
                                                                <table
                                                                    style={{
                                                                        width: '100%',
                                                                        borderCollapse: 'collapse',
                                                                        textAlign: 'center'
                                                                    }}
                                                                >
                                                                    <thead>
                                                                        <tr>
                                                                            <th style={cellStyle}>Unidade</th>
                                                                            <th style={cellStyle}>Disponível</th>
                                                                            <th style={cellStyle}>Qtd a Sair</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {estoquePorUnidade.map(u => (
                                                                            <LinhaReserva
                                                                                key={u.idArmazenamento}
                                                                                unidade={u}
                                                                                onChange={(valor) => {
                                                                                    setReservasPorUnidade(prev => ({
                                                                                        ...prev,
                                                                                        [u.idArmazenamento]: valor
                                                                                    }));
                                                                                }}
                                                                            />
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </Grid>
                                                    </Grid>


                                                </Grid>

                                                <Grid
                                                    xs={12}
                                                    direction="row"
                                                    align="center" // 👈 importante
                                                    style={{ margin: 3 }}
                                                    spacing={1}
                                                >


                                                    <Grid align="center" item xs={1} style={{ padding: 2 }}>
                                                        <Button style={{ marginTop: 1 }}
                                                            variant="contained"
                                                            color="primary"
                                                            startIcon={<AddCircleIcon />}
                                                            onClick={adicionar}
                                                            sx={{
                                                                borderRadius: '12px',
                                                                textTransform: 'none',
                                                                fontWeight: 'bold',
                                                                padding: '8px 20px',
                                                                boxShadow: '0 4px 14px 0 rgba(0,118,255,0.39)',
                                                            }}
                                                        > Adicionar  </Button>
                                                    </Grid>

                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    container
                                                    justifyContent="flex-end"
                                                    align="flex-end"
                                                    style={{ paddingTop: 16 }}
                                                >
                                                    <Grid
                                                        direction="row"
                                                        justifyContent="center"
                                                        align="center"
                                                        item xs={1}
                                                        container
                                                    >
                                                        {saidaEstoque.caminho_arquivo_assinado ? (
                                                            <div>
                                                                <div
                                                                    onClick={() => {
                                                                        const link = saidaEstoque.caminho_arquivo_assinado.replaceAll(
                                                                            "/home/wwgrup/saidaestoque/",
                                                                            "https://gruporosinetos.com/saidaestoquemidias/"
                                                                        );
                                                                        window.open(link, "_blank", "noopener,noreferrer");
                                                                    }}
                                                                    style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', margin: 0, width: '50px' }}
                                                                >
                                                                    <img alt={'miniatura_pdf'} style={{ width: '40px' }} src={miniatura_pdf} />
                                                                    <Typography align="center" variant="caption" style={{ fontSize: '10px', color: themeHelper.text }}>
                                                                        Assinado
                                                                    </Typography>
                                                                </div>
                                                                <IconButton {...getRootArquivoProps1()} size="small" style={{ color: themeHelper.text }}>
                                                                    <input {...getInputArquivoProps1()} />
                                                                    <SwapHorizIcon fontSize="small" />
                                                                </IconButton>
                                                            </div>
                                                        ) : (
                                                            <div {...getRootArquivoProps1()} style={{ ...dropzoneStyles, padding: '5px', width: '60px', borderColor: themeHelper.border }}>
                                                                <input {...getInputArquivoProps1()} />
                                                                <DescriptionIcon style={{ color: themeHelper.text }} />
                                                                <Typography align="center" variant="caption" style={{ display: 'block', fontSize: '10px', color: themeHelper.text }}>
                                                                    Anexa PDF Assinado
                                                                </Typography>
                                                            </div>
                                                        )}
                                                    </Grid>

                                                    <Grid align="center" item xs={1} style={{ padding: 2 }}>
                                                        <Button style={{ marginTop: 1 }}
                                                            variant="contained"
                                                            color="info"
                                                            startIcon={<PictureAsPdfIcon />}
                                                            onClick={(e) => gerarPDF()}
                                                            sx={{
                                                                borderRadius: '12px',
                                                                textTransform: 'none',
                                                                fontWeight: 'bold',
                                                                padding: '8px 24px',
                                                                boxShadow: '0 4px 14px 0 rgba(2,136,209,0.39)',
                                                            }}
                                                        > Gerar PDF  </Button>
                                                    </Grid>

                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    container
                                                    justifyContent="center"
                                                    style={{ paddingTop: 16 }}
                                                >
                                                    <div
                                                        key={tabelaKey}
                                                        style={{
                                                            width: '100%',
                                                            maxWidth: '95%',
                                                            overflowX: 'auto',
                                                            backgroundColor: themeHelper.paper,
                                                            borderRadius: 8,
                                                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                            border: `1px solid ${themeHelper.border}`,
                                                            padding: 16,
                                                        }}
                                                    >
                                                        {/* largura mínima para forçar scroll */}
                                                        <div style={{ minWidth: '1200px' }}>
                                                            <DataGrid
                                                                key={itens.length > 0 ? itens[0].id_item_requerimento : 'grid'}
                                                                pagination
                                                                checkboxSelection={false}
                                                                rows={itens}
                                                                getRowId={(row) => row.id_item_requerimento}
                                                                disableColumnResize={false}
                                                                onCellClick={handleCellClick}
                                                                onRowClick={handleRowClick}
                                                                components={{
                                                                    Toolbar: CustomToolbar,
                                                                }}
                                                                columns={columnsDataGrid.map(column => ({
                                                                    ...column,
                                                                    disableColumnMenu: true,
                                                                }))}
                                                                autoHeight
                                                            />
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </SwipeableViews>
                                    </Grid>
                                </Grid>
                            </React.Fragment>
                        }
                    </Container>

                    <Snackbar
                        open={openAtualizando}
                        autoHideDuration={1500}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    >
                        <MuiAlert elevation={6} variant="filled"  >
                            Atualizando...
                        </MuiAlert>
                    </Snackbar>

                    <Dialog
                        open={openAutorizar}
                        onClose={() => handleCloseOpenAutorizar()}
                        aria-labelledby="autorize-dialog"
                    >
                        <DialogTitle id="autorize-dialog">{"Autorizar Saída de Estoque"}</DialogTitle>
                        <DialogContent>{"Digite o Código do Aplicativo Autenticador"}</DialogContent>
                        <Grid item xs={12} style={{ padding: 5 }}>
                            <TextField
                                id="codigoValidacao"
                                variant="standard"
                                name="codigoValidacao"
                                fullWidth
                                label="Código de Validação"
                                value={codigoValidacao}
                                onChange={(e) => setCodigoValidacao(e.target.value)}
                            />

                        </Grid>
                        <DialogActions>
                            <Button
                                variant="contained"
                                onClick={() => handleCloseOpenAutorizar()}
                                color="secondary"
                            >
                                Cancelar
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    autorizar();
                                }}
                                color="default"
                            >
                                Autorizar
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={openModalSolicitarAutorizacao}
                        onClose={() => setOpenModalSolicitarAutorizacao(false)}
                        maxWidth="sm"
                        fullWidth
                    >
                        <DialogTitle>{"Solicitar Autorização de Saída"}</DialogTitle>
                        <DialogContent>
                            <Box sx={{ mt: 2 }}>
                                <Typography variant="body1" sx={{ mb: 2 }}>
                                    Selecione o usuário que deve autorizar esta saída de estoque.
                                </Typography>
                                <Autocomplete
                                    id="select-autorizador"
                                    options={solicitantesDisponiveis || []}
                                    getOptionLabel={(option) => returnDescricaoSolicitante(option).replace(/<br \/>/g, '\n')}
                                    value={solicitantesDisponiveis?.find(u => u.id_usuario === idUsuarioAutorizador) || null}
                                    onChange={(event, newValue) => {
                                        setIdUsuarioAutorizador(newValue ? newValue.id_usuario : null);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Usuário Autorizador"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    )}
                                />
                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpenModalSolicitarAutorizacao(false)} color="secondary">
                                Cancelar
                            </Button>
                            <Button
                                onClick={solicitarAutorizacaoEspecificaAPI}
                                color="primary"
                                variant="contained"
                                disabled={!idUsuarioAutorizador || botaoClicado}
                            >
                                Confirmar Solicitação
                            </Button>
                        </DialogActions>
                    </Dialog>


                </div>
            </MuiThemeProvider >
        </CoreThemeProvider >
    );
}

// ===============================
// LINHA
// ===============================
function LinhaReserva({ unidade, onChange }) {

    const [valor, setValor] = useState(unidade.reservado);
    const [alterado, setAlterado] = useState(false);

    useEffect(() => {
        setValor(unidade.reservado);
        setAlterado(false);
    }, [unidade]);

    const maxPermitido = unidade.disponivel + unidade.reservado;

    return (
        <tr>
            <td>{unidade.unidade}</td>
            <td>{unidade.disponivel}</td>
            <td>
                <TextField
                    type="number"
                    size="small"
                    value={valor}
                    inputProps={{ min: 0, max: maxPermitido }}
                    onChange={(e) => {
                        let v = parseInt(e.target.value, 10) || 0;
                        if (v < 0) v = 0;
                        if (v > maxPermitido) v = maxPermitido;

                        setValor(v);
                        setAlterado(true);

                        if (onChange) {
                            onChange(v);
                        }
                    }}
                />
            </td>
        </tr>
    );
}